export const CUSTOM_AUTOMATION_ACTIONS = {
  CANCEL: 'cancel_automation',
  PAUSE: 'pause_automation',
  START: 'start_automation',
  START_AND_RESUME: 'start_and_resume_automation',
};

export const CUSTOM_SMART_CONNECTOR_ACTIONS = {
  START: 'start_smart_connector',
};

const Actions = {
  automations: Object.values(CUSTOM_AUTOMATION_ACTIONS),
  smartConnectors: Object.values(CUSTOM_SMART_CONNECTOR_ACTIONS),
};

export const isAutomationAction = (action) => {
  return Actions.automations.includes(action);
};

export const isSmartConnectorAction = (action) => {
  return Actions.smartConnectors.includes(action);
};
